<template>
  <div class="map_box">
    <!-- <nColorBarGD
      :min.sync="min"
      :max.sync="max"
      :dataType="draw_options.sensortype"
      :colorType.sync="tileSty"
      :option="{ colorType: true, optBtn: false, advanced: { barType: true } }"
    >
    </nColorBarGD> -->

    <base-map
      @map="initMap"
      :zoom="zoom"
      height="100%"
      width="auto"
      :month="month"
      :map-id="main_map"
      :sensortype="draw_options.sensortype"
      :colorType="colorType"
      :isExtraShow="true"
      :showTitle="true"
      :colorBarDraggable="showColorBarDrag"
    ></base-map>

    <transition-panel>
      <a-spin :spinning="spinning" slot="content">
        <div style="margin-top: 16px">
          图层显示：
          <a-checkbox-group
            v-model="layerList"
            name="checkboxgroup"
            :options="checkboxOptions"
            @change="onLayerChange"
          />
        </div>
        <div style="margin-top: 16px">
          参数显示：
          <a-radio-group v-model="draw_options.sensortype" button-style="solid">
            <a-radio-button
              :value="item.value"
              v-for="item in sensortypes"
              :key="item.value"
              >{{ item.label }}</a-radio-button
            >
          </a-radio-group>
        </div>
        <div style="margin-top: 16px">
          选择日期：
          <a-range-picker v-model="time" format="YYYY-MM-DD HH:mm:ss" />
          &nbsp;&nbsp;路线筛选：
          <a-select
            style="width: 200px"
            placeholder="请选择路线进行筛选"
            allowClear
            v-model="roadId"
          >
            <a-select-option
              v-for="item in roadList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
        <a-button
          type="primary"
          icon="plus"
          style="margin:16px 0"
          @click="
            visible = true;
            action = 'add';
          "
          >创建巡查任务</a-button
        >
        <a-table
          :columns="columns"
          :loading="tableLoading"
          :data-source="list"
          size="small"
          rowKey="id"
          :customRow="clickRow"
          :rowClassName="rowClassName"
          :pagination="{
            current: page,
            total: total,
            pageSize: size,
            onChange: onPageChange
          }"
        >
          <span slot="idx" slot-scope="text, record, index">
            {{ (page - 1) * size + index + 1 }}
          </span>
          <span slot="time" slot-scope="text, record">
            {{
              record.start_time
                ? moment(record.start_time).format("YYYY-MM-DD")
                : ""
            }}
          </span>
          <span slot="task_status" slot-scope="text">
            <a-badge status="success" v-if="text == 0" />
            <a-badge status="processing" v-else-if="text == 1" />
            <a-badge status="error" v-else-if="text == 4" />
            {{ text | taskStatusFormat }}
          </span>
          <template slot="operation" slot-scope="text, record">
            <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm
              title="确认要删除么？"
              ok-text="是"
              cancel-text="否"
              @confirm="handleDelete(record.id)"
              @cancel="
                () => {
                  $message.error('取消删除');
                }
              "
            >
              <a style="color: #1890ff">删除 </a>
            </a-popconfirm>
            <a-divider type="vertical" />
            <a @click="openChart(record)">图表</a>
            <a-divider type="vertical" />
            <a @click="exportData(record)">导出</a>
            <span v-if="userMenuPower.controls.showPlayBackTask">
              <a-divider type="vertical" />
              <a @click="playBack(record)">回放</a>
            </span>
          </template>
        </a-table>
      </a-spin>
    </transition-panel>
    <add-or-edit-patrol-task
      :action="action"
      :visible.sync="visible"
      :record="record"
      :trackDataInfo="trackDataInfo"
      @onOk="
        v => {
          visible = v;
          getTaskList();
        }
      "
    ></add-or-edit-patrol-task>
    <patrol-chart
      v-if="showChart"
      :sensortype="draw_options.sensortype"
      :trackDataInfo="trackDataInfo"
      :tableCurrRow="tableCurrRow"
      @closeChart="v => (showChart = v)"
    >
      <a-button
        v-show="tableCurrRow.video_url && tableCurrRow.video_status == 1"
        slot="extra"
        type="primary"
        size="small"
        icon="video-camera"
        class="open-video-btn"
        @click="openVideo"
        >视频</a-button
      >
    </patrol-chart>
    <boat-real-video
      class="fix-video-wrapper"
      v-if="curUrl"
      ref="real_video"
      :board_id="tableCurrRow.board_id"
      :url="curUrl"
      @close="curUrl = ''"
    ></boat-real-video>
    <playback-task
      :map="map"
      :trackDataInfo="trackDataInfo"
      v-if="showPlayback"
      @playEnd="showPlayback = false"
    ></playback-task>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import BaseMap from "@/components/BaseMapNew";
import BoatRealVideo from "@/components/BoatRealVideo";
import TransitionPanel from "@/components/TransitionPanel";
import AddOrEditPatrolTask from "./components/AddOrEditPatrolTask";
import PatrolChart from "./components/PatrolChart";
import PlaybackTask from "./components/PlaybackTask";
import {
  openWzStationWindow,
  openTrackPointWindow,
  openPointLayerWindow
} from "@/utils/open_station_window";
import {
  getCurrentData,
  getPatrolTaskList,
  deletePatrolTask,
  getHistoryData,
  getPatrolRouteList
} from "@/api/api";
import { flattenArrayDeep, isCheckNumber } from "@/utils/utils";
import { patrol_record_columns } from "@/options/columns";
import { OSS_BASE_URL } from "@/config/config";
import { taskStatusOptions } from "@/options/common";
import FileSaver from "@/utils/plugins/FileSaver";
import moment from "moment";
import * as turf from "@turf/turf";

const checkboxOptions = [
  { label: "微站", value: "wz", layer: "pointLayer" },
  { label: "水质走航", value: "track", layer: "trackLayer" },
  { label: "声呐", value: "sonar", layer: "sonarLayer" },
  { label: "ADCP", value: "adcp", layer: "adcpLayer" },
  { label: "正摄图", value: "main", layer: "mainLayer" },
  { label: "手机照片", value: "other", layer: "otherLayer" }
];

export default {
  data() {
    return {
      wzList: [],
      pointLayer: null,
      sonarLayer: null,
      adcpLayer: null,
      mainLayer: null,
      otherLayer: null,
      trackLayer: null,
      chooseStation: {},
      main_map: "record_map",
      zoom: {
        value: 9,
        max: 17,
        min: 5,
        show: true
      },
      tileSty: "static_gradient",
      colorType: "static",
      map: null,
      min: 0,
      max: 1,
      group_id: null,
      activeKey: "1",
      draw_options: {
        sensortype: "pm10",
        drawtype: "point",
        drawname: false,
        showcar: true,
        mode: "realtime"
      },
      spinning: false,
      month: this.$moment().format("YYYY-MM-DD"),
      checkboxOptions,
      layerList: [],
      time: [
        this.$moment("2023-10-01 00:00:00").format("YYYY-MM-DD HH:mm:00"),
        this.$moment().format("YYYY-MM-DD HH:mm:00")
      ],
      columns: patrol_record_columns,
      list: [],
      visible: false,
      record: {},
      action: "",
      page: 1,
      size: 10,
      total: 0,
      tableCurrRow: {},
      trackDataInfo: {},
      showChart: false,
      curUrl: "",
      showPlayback: false,
      roadList: [],
      roadId: undefined,
      showColorBarDrag: false,
      tableLoading: false
    };
  },
  components: {
    BaseMap,
    TransitionPanel,
    AddOrEditPatrolTask,
    PatrolChart,
    BoatRealVideo,
    PlaybackTask
  },
  watch: {
    time() {
      this.getTaskList();
    },
    roadId() {
      this.getTaskList();
    },
    intensity() {
      this.drawPoints();
      this.drawTrackPoints();
    },
    layerList() {
      this.drawPoints();
      this.drawSonarPoints();
      this.drawAdcpPoints();
      this.drawMainPoints();
      this.drawOtherPoints();
      this.setLayerFitView();
      this.drawTrackPoints();
    },
    wzList() {
      this.drawPoints();
    },
    tableCurrRow() {
      this.curUrl = "";
      this.map?.clearInfoWindow();
      this.getTrackDataInfo();
      // this.drawTrackPoints();
    },
    trackDataInfo() {
      this.drawSonarPoints();
      this.drawAdcpPoints();
      this.drawMainPoints();
      this.drawOtherPoints();
      this.setLayerFitView();
      this.drawTrackPoints();
    }
  },
  computed: {
    ...mapState([
      "authUserInfo",
      "userMenuPower",
      "sensortypes",
      "projectInfo",
      "colorRange",
      "groupTree"
    ]),
    ...mapGetters(["defaultInfo"]),
    intensity() {
      return new colorIntensity.getIntensity({
        dataType: this.draw_options.sensortype,
        max: this.colorRange[1],
        min: this.colorRange[0],
        colorType: this.colorType
      });
    },
    options() {
      let opts = {
        zIndex: 110,
        showValue: true,
        showTitle: true,
        drawCircle: false,
        intensity: this.intensity,
        titleKey: "name",
        valueKey: this.draw_options.sensortype,
        icon: "",
        callback: this.clickPoint
      };
      return opts;
    },
    trackLayerOpts() {
      return {
        zIndex: 10,
        drawMode: "point",
        intensity: this.intensity,
        point: {
          valueKey: this.draw_options.sensortype,
          // fillStyle: 'blue',
          size: 6
        },
        events: {
          click: e => {
            // 不显示电导率
            let sensortypes = this.sensortypes.filter(
              x => x.value != "conductivity"
            );
            openTrackPointWindow({
              info: e,
              sensortypes: sensortypes
            });
          }
        }
      };
    }
  },
  filters: {
    taskStatusFormat(value) {
      const info = taskStatusOptions.find(x => x.value == value);
      if (info) {
        return info.label;
      }
      return "";
    }
  },
  created() {
    this.draw_options.sensortype = this.defaultInfo.defaultSensorType;
    this.group_id = this.defaultInfo.defaultGroupId;
    if (this.userMenuPower.controls.showColorBarDrag) {
      this.showColorBarDrag = true;
    }
  },
  mounted() {
    this.getTaskList();
    this.getCurrentData();
    this.getRoadList();
  },
  methods: {
    moment,
    async getRoadList() {
      try {
        let res = await getPatrolRouteList({
          group_id: this.defaultInfo.defaultGroupId
        });
        let data = res.data.items;
        this.roadList = data;
      } catch (error) {
        console.log(error);
      }
    },
    openVideo() {
      this.curUrl = OSS_BASE_URL + this.tableCurrRow.video_url;
    },
    clickRow(record, index) {
      return {
        on: {
          click: () => {
            this.tableCurrRow = record;
          }
        }
      };
    },
    rowClassName(record, index) {
      return record.id === this.tableCurrRow.id ? "blue" : "white";
    },
    async getTaskList() {
      try {
        let res = await getPatrolTaskList({
          group_id: this.defaultInfo.defaultGroupId,
          start_time: this.time[0]
            ? this.$moment(this.time[0]).format("YYYY-MM-DD HH:mm:ss")
            : null,
          end_time: this.time[1]
            ? this.$moment(this.time[1]).format("YYYY-MM-DD HH:mm:ss")
            : this.$moment(this.time[0])
                .add(1, "days")
                .format("YYYY-MM-DD 00:00:00"),
          road_id: this.roadId ? this.roadId : null,
          page: this.page,
          size: this.size
        });
        this.list = res.data.items;
        this.total = res.data.total;
        if (this.list.length) {
          this.tableCurrRow = this.list[0];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTrackDataInfo() {
      this.tableLoading = true;
      if (!this.tableCurrRow?.start_time) {
        this.tableLoading = false;
        return;
      }
      const flattenTreeArr = flattenArrayDeep(this.groupTree);
      let patrolDevices = flattenTreeArr.filter(
        x => x.dev_type == 2 || x.dev_type == 3
      );
      try {
        let curInfo = patrolDevices.find(
          x => x.id == this.tableCurrRow.board_id
        );
        if (curInfo) {
          let res = await getHistoryData(
            this.group_id,
            curInfo.id,
            "sec",
            null,
            this.tableCurrRow.start_time,
            this.tableCurrRow.end_time
              ? this.tableCurrRow.end_time
              : this.$moment(this.tableCurrRow.start_time)
                  .add(1, "days")
                  .format("YYYY-MM-DD 00:00:00"),
            "2,3"
          );
          let deviceData = res.data.data;
          this.sensortypes.forEach(s => {
            const index = deviceData.columns.findIndex(x => x == s.value);
            deviceData.data.forEach(item => {
              if (index > -1) {
                item[index] = this.$sr(s.value, item[index]);
              }
            });
          });
          const validData = [];
          for (let item of deviceData.data) {
            // 某个参数有值就是有效的
            let is_valid = false;
            for (let s of this.sensortypes) {
              const index = deviceData.columns.indexOf(s.value);
              if (isCheckNumber(item[index])) {
                is_valid = true;
                break;
              }
            }
            // 去掉无效数据
            if (!is_valid) {
              continue;
            }
            validData.push(item);
          }
          this.trackDataInfo = {
            columns: deviceData.columns,
            data: validData,
            station: curInfo
          };
        }
        this.tableLoading = false;
      } catch (error) {
        this.trackDataInfo = {};
        this.tableLoading = false;
        console.log(error);
      }
    },
    async drawTrackPoints() {
      // this.trackLayer && this.trackLayer.destroy();
      this.trackLayer && this.trackLayer.setMap(null);
      if (!this.layerList.includes("track")) {
        return;
      }
      let list = [];
      let coordinateArr = [];
      if (Object.keys(this.trackDataInfo).length) {
        let columns = this.trackDataInfo.columns;
        let lngIndex = columns.findIndex(x => x == "lng");
        let latIndex = columns.findIndex(x => x == "lat");
        let dataTypeIndex = columns.findIndex(
          x => x == this.draw_options.sensortype
        );
        let data = this.trackDataInfo.data;
        for (let item of data) {
          if (item[lngIndex] == 0 || item[latIndex] === 0) {
            continue;
          }
          if (!isCheckNumber(item[dataTypeIndex])) {
            continue;
          }
          let obj = {};
          columns.forEach((name, idx) => {
            obj[name] = item[idx];
          });
          let gcj = coordtransform.wgs84togcj02(item[lngIndex], item[latIndex]);
          list.push({
            ...obj,
            lng: gcj[0],
            lat: gcj[1],
            time: moment(item[0] * 1000).format("YYYY-MM-DD HH:mm:ss"),
            name: this.trackDataInfo.station.name,
            lnglat: [gcj[0], gcj[1]]
          });
          coordinateArr.push(turf.point([gcj[0], gcj[1]]));
        }
      }
      if (coordinateArr.length) {
        let centerInfo = turf.center(turf.featureCollection(coordinateArr));
        let point = new AMap.LngLat(
          centerInfo.geometry.coordinates[0],
          centerInfo.geometry.coordinates[1]
        );
        this.map.setZoom(this.map.getZoom() < 13 ? 13 : this.map.getZoom());
        // 地图中心点像素值
        let centerPixel = this.map.lngLatToContainer(this.map.getCenter());
        // 点位像素值
        let pointPixel = this.map.lngLatToContainer(point);
        this.map.panBy(
          240 - (pointPixel.x - centerPixel.x),
          0 - (pointPixel.y - centerPixel.y)
        );
      }

      // this.trackLayer = new nMapGD.CanvasCommonLayer(
      //   this.map,
      //   list,
      //   this.trackLayerOpts
      // );

      // 解决使用nMapGD.CanvasCommonLayer数据点重合时点击事件问题，改用MarkerCluster
      this.trackLayer = new AMap.MarkerCluster(this.map, list, {
        gridSize: 60, // 设置网格像素大小
        maxZoom: 8, // 设置最大聚合级别
        renderMarker: context => {
          const curBgColor = this.intensity.bgcolor.getColor(
            context.data?.[0]?.[this.draw_options.sensortype]
          );
          context.marker.setOffset(new AMap.Pixel(-7, -7));
          context.marker.setContent(`
            <div class="custom-track-marker-class" style="background-color: ${curBgColor}"></div>
          `);
          context.marker.on("click", e => {
            // 不显示电导率
            let sensortypes = this.sensortypes.filter(
              x => x.value != "conductivity"
            );
            openTrackPointWindow({
              info: context.data?.[0] || {},
              sensortypes: sensortypes
            });
          });
        }, // 自定义非聚合点样式
        renderClusterMarker: context => {
          const curBgColor = this.intensity.bgcolor.getColor(
            context.clusterData?.[0]?.[this.draw_options.sensortype]
          );
          context.marker.setOffset(new AMap.Pixel(-7, -7));
          context.marker.setContent(`
            <div class="custom-track-marker-class" style="background-color: ${curBgColor}"></div>
          `);
          context.marker.on("click", e => {
            // 不显示电导率
            let sensortypes = this.sensortypes.filter(
              x => x.value != "conductivity"
            );
            openTrackPointWindow({
              info: context.clusterData?.[0] || {},
              sensortypes: sensortypes
            });
          });
        } // 自定义聚合点样式
      });
    },
    drawPoints() {
      this.clearPoints();
      if (!this.layerList.includes("wz")) {
        return;
      }
      let pointMarkers = [];
      let list = this.$_.cloneDeep(this.wzList);
      for (let i of list) {
        const gcj = coordtransform.bd09togcj02(i.lng, i.lat);
        i.lng = gcj[0];
        i.lat = gcj[1];
        i.name = i.station_name;
        i[this.draw_options.sensortype] =
          i[this.draw_options.sensortype] ?? "--";
        pointMarkers.push(i);
      }
      let layer = new nMapGD.StationLayer(this.map, pointMarkers, this.options);
      this.pointLayer = layer;
    },
    clearPoints() {
      this.pointLayer && this.pointLayer.destroy();
    },
    setLayerFitView() {
      const layerListFilter = this.layerList.filter(
        x => !["track", "wz"].includes(x)
      );
      if (!layerListFilter.length) {
        return;
      }
      let coordinateArr = [];
      for (let value of layerListFilter) {
        let layerInfo = checkboxOptions.find(x => x.value === value);
        const coordList = this[layerInfo.layer]?.data;
        if (!coordList?.length) {
          continue;
        }
        for (let item of coordList) {
          // 根据巡检记录id过滤
          if (item.patrol_record_id == this.tableCurrRow.id) {
            coordinateArr.push(turf.point([item.lng, item.lat]));
          }
        }
      }

      if (coordinateArr.length) {
        let centerInfo = turf.center(turf.featureCollection(coordinateArr));
        let point = new AMap.LngLat(
          centerInfo.geometry.coordinates[0],
          centerInfo.geometry.coordinates[1]
        );
        this.map.setZoom(this.map.getZoom() < 13 ? 13 : this.map.getZoom());

        // 地图中心点像素值
        let centerPixel = this.map.lngLatToContainer(this.map.getCenter());
        // 点位像素值
        let pointPixel = this.map.lngLatToContainer(point);
        this.map.panBy(
          240 - (pointPixel.x - centerPixel.x),
          0 - (pointPixel.y - centerPixel.y)
        );
      }
    },
    drawSonarPoints() {
      this.sonarLayer?.destroy();
      this.sonarLayer = null;

      if (!this.layerList.includes("sonar")) {
        return;
      }
      if (!this.tableCurrRow?.pic_sonar?.length) {
        return;
      }
      let picList = this.tableCurrRow.pic_sonar;
      const markers = [];
      picList.forEach(item => {
        markers.push({
          ...item,
          pic_list: picList,
          patrol_record_id: this.tableCurrRow.id
        });
      });

      let opts = {
        zIndex: 10,
        drawMode: "icon",
        icon: {
          img: "static/images/声呐.png",
          width: 36,
          height: 46.8,
          deg: 0
        },
        point: {
          size: 5
        },
        events: {
          click: e => {
            openPointLayerWindow({ info: e, type: "sonar" });
          }
        }
      };
      this.sonarLayer = new nMapGD.CanvasCommonLayer(this.map, markers, opts);
    },
    drawAdcpPoints() {
      this.adcpLayer?.destroy();
      this.adcpLayer = null;

      if (!this.layerList.includes("adcp")) {
        return;
      }
      if (!this.tableCurrRow?.pic_adcp?.length) {
        return;
      }
      let picList = this.tableCurrRow.pic_adcp;
      const markers = [];
      picList.forEach(item => {
        markers.push({
          ...item,
          pic_list: picList,
          patrol_record_id: this.tableCurrRow.id
        });
      });

      let opts = {
        zIndex: 10,
        drawMode: "icon",
        icon: {
          img: "static/images/ADCP.png",
          width: 36,
          height: 46.8,
          deg: 0
        },
        point: {
          size: 5
        },
        events: {
          click: e => {
            openPointLayerWindow({ info: e, type: "adcp" });
          }
        }
      };
      this.adcpLayer = new nMapGD.CanvasCommonLayer(this.map, markers, opts);
    },
    drawMainPoints() {
      this.mainLayer?.destroy();
      this.mainLayer = null;

      if (!this.layerList.includes("main")) {
        return;
      }
      if (!this.tableCurrRow?.pic_main?.length) {
        return;
      }
      let picList = this.tableCurrRow.pic_main;
      const markers = [];
      picList.forEach(item => {
        markers.push({
          ...item,
          pic_list: picList,
          patrol_record_id: this.tableCurrRow.id
        });
      });

      let opts = {
        zIndex: 10,
        drawMode: "icon",
        icon: {
          img: "static/images/正摄图.png",
          width: 36,
          height: 46.8,
          deg: 0
        },
        point: {
          size: 5
        },
        events: {
          click: e => {
            openPointLayerWindow({ info: e, type: "main" });
          }
        }
      };
      this.mainLayer = new nMapGD.CanvasCommonLayer(this.map, markers, opts);
    },
    drawOtherPoints() {
      this.otherLayer?.destroy();
      this.otherLayer = null;

      if (!this.layerList.includes("other")) {
        return;
      }
      if (!this.tableCurrRow?.pic_other?.length) {
        return;
      }
      let picList = this.tableCurrRow.pic_other;
      const markers = [];
      picList.forEach(item => {
        markers.push({
          ...item,
          pic_list: picList,
          patrol_record_id: this.tableCurrRow.id
        });
      });

      let opts = {
        zIndex: 10,
        drawMode: "icon",
        icon: {
          img: "static/images/手机照片.png",
          width: 36,
          height: 46.8,
          deg: 0
        },
        point: {
          size: 5
        },
        events: {
          click: e => {
            openPointLayerWindow({ info: e, type: "other" });
          }
        }
      };
      this.otherLayer = new nMapGD.CanvasCommonLayer(this.map, markers, opts);
    },
    async getCurrentData() {
      try {
        let res = await getCurrentData(this.group_id, "min", "1");
        this.wzList = res.data.data;
        this.wzList.forEach(item => {
          const diffSeconds = moment().diff(moment(item.time), "seconds");
          this.sensortypes.forEach(s => {
            item[s.value] =
              diffSeconds > process.env.VUE_APP_OFFLINE_SECONDS
                ? "--"
                : this.$sr(s.value, item[s.value]) || "--";
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    initMap(map) {
      this.map = map;
    },
    onLayerChange(v) {
      this.layerList = v;
    },
    handleEdit(record) {
      this.record = record;
      this.action = "edit";
      this.visible = true;
    },
    async handleDelete(id) {
      try {
        let res = await deletePatrolTask(id);
        await this.getTaskList();
        this.$message.success(res.data.msg);
      } catch (error) {
        console.log(error);
      }
    },
    openChart(record) {
      this.record = record;
      this.showChart = true;
    },
    playBack(record) {
      this.record = record;
      this.showPlayback = true;
      // 回放时打开水质走航
      if (!this.layerList.includes("track")) {
        this.layerList.push("track");
      }
    },
    async exportData(record) {
      if (!record?.start_time) {
        return;
      }
      const flattenTreeArr = flattenArrayDeep(this.groupTree);
      let patrolDevices = flattenTreeArr.filter(
        x => x.dev_type == 2 || x.dev_type == 3
      );
      try {
        let curInfo = patrolDevices.find(x => x.id == record.board_id);
        if (curInfo) {
          let res = await getHistoryData(
            this.group_id,
            curInfo.id,
            "sec",
            null,
            record.start_time,
            record.end_time
              ? record.end_time
              : this.$moment(record.start_time)
                  .add(1, "days")
                  .format("YYYY-MM-DD 00:00:00"),
            "2,3"
          );
          let deviceData = res.data.data;
          this.sensortypes.forEach(s => {
            const index = deviceData.columns.findIndex(x => x == s.value);
            deviceData.data.forEach(item => {
              if (index > -1) {
                item[index] = this.$sr(s.value, item[index]);
              }
            });
          });
          const { columns, data } = deviceData;
          // 无人船不显示电导率
          let sensortypes = this.sensortypes.filter(
            x => x.value != "conductivity"
          );
          sensortypes = sensortypes.map(x => x.value);
          // 导出的字段
          const fields = ["time", "station_id"]
            .concat(sensortypes)
            .concat(["lat", "lng"]);
          const content = [];
          content[0] = [`${fields.join(",")} \n`];
          for (let item of data) {
            const curInfo = this.$_.cloneDeep(item);
            // 某个参数有值就是有效的
            let is_valid = false;
            for (let s of sensortypes) {
              const index = columns.indexOf(s);
              if (isCheckNumber(curInfo[index])) {
                is_valid = true;
                break;
              }
            }
            // 去掉无效数据
            if (!is_valid) {
              continue;
            }
            const text = [];
            fields.forEach(x => {
              const index = columns.indexOf(x);
              if (x == "time") {
                text.push(
                  `${moment
                    .unix(curInfo[index])
                    .format("YYYY-MM-DD HH:mm:ss")}\t`
                );
              } else {
                text.push(curInfo[index]);
              }
            });
            content.push(`${text}\n`);
          }
          var blob = new Blob(content, { type: "text/plain;charset=utf-8" });
          FileSaver.saveAs(blob, `${record.name}.csv`);
        }
      } catch (error) {
        this.trackDataInfo = {};
        console.log(error);
      }
    },
    clickPoint(e) {
      this.chooseStation = e;
      openWzStationWindow({
        group_id: this.group_id,
        map: this.map,
        point: e.point,
        station: this.chooseStation,
        timeType: "min",
        dataType: this.draw_options.sensortype,
        sensor_types: this.projectInfo.sensorType
      });
    },
    onPageChange(v) {
      this.page = v;
      this.getTaskList();
    }
  }
};
</script>
<style lang="less" scoped>
.open-video-btn {
  position: absolute;
  bottom: 275px;
  top: 2px;
  right: 24px;
  z-index: 101;
}
/deep/ .ant-table-tbody .blue {
  background-color: #b8dcff !important;
}
</style>
